import HttpUtil from '../HttpUtil'

let configDomain = process.env.DOMAIN
const indexApi = {
  /**
   * 盈店精选商品分类
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getElitesCateList (params) {
    let postUrl = configDomain + '/bshop/config/elites/cate/list'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 热门商家列表
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getShopChoiceList (params) {
    let postUrl = configDomain + '/buyer/shop/choice/list'
    return HttpUtil.get(postUrl, params)
  },
  getVisitorId() {
    return HttpUtil.get(`${configDomain}/buyer/visitor/info`)
  },
  getPriceInfo(params) {
    return HttpUtil.post(`${configDomain}/buyer/product/logistics/list/calculate`, params, false, 'json')
  },
  /**
   * 分类列表
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getChoiceSyscategoryList (params) {
    let postUrl = configDomain + '/buyer/product/choice/syscategory/list'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 商品产地列表
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getChoicePlaceList (params) {
    let postUrl = configDomain + '/buyer/product/choice/place/list'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * shop产品列表
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getProductChoiceList (params) {
    let postUrl = configDomain + '/buyer/product/choice/list'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * shop列表
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getProductChoiceShopList (params) {
    let postUrl = configDomain + '/buyer/product/choice/shop/list'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 左侧菜单栏接口
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getProductChoiceAllinfo (params) {
    let postUrl = configDomain + '/buyer/product/choice/allinfo'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 购物车商品列表
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getBuyerCartList (params) {
    let postUrl = configDomain + '/buyer/cart/list'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 商品列表详情2.0接口
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getBuyerProductDetail (params) {
    let postUrl = configDomain + '/buyer/product/detail'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 购物车移除商品接口
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getCartRemoveproduct (params) {
    let postUrl = configDomain + '/buyer/cart/removeproduct'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 购物车新添商品接口
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getCartUpdatequantity (params) {
    let postUrl = configDomain + '/buyer/cart/update'
    return HttpUtil.post(postUrl, params)
  },
  getCalculatePrice(params) {
    return HttpUtil.post(`${configDomain}/buyer/order/amount/calculate`, params)
  },
  getPaypalAddress(params) {
    return HttpUtil.get(`${configDomain}/buyer/order/paypal/shipping`, params)
   },
  /**
   * 订单创建接口
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  orderCreate (params) {
    let postUrl = configDomain + '/buyer/order/create/new'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 订单付款接口
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAddressList(params) {
    let postUrl = configDomain + '/buyer/product/detail'
    return HttpUtil.get(postUrl, params)
  },
  orderPayNew (params) {
    let postUrl = configDomain + '/buyer/order/pay/new'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 订单付款接口二
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  orderCaptureInfo (params) {
    let postUrl = configDomain + '/buyer/order/capture/info'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 订单付款接口集成
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  orderPayTotal (params) {
    let postUrl = configDomain + '/buyer/order/pay/total'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 用户登录接口
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAccountInfo (params) {
    let postUrl = configDomain + '/buyer/person/account/info'
    return HttpUtil.get(postUrl, params)
  },
  getAccountCheck(params) {
    return HttpUtil.post(`${configDomain}/buyer/forget/account/check`, params);
  },
  getLoginKey(params) {
    return HttpUtil.get(`${configDomain}/buyer/login/key/get`, params)
  },
  toLogin(data) {
    return HttpUtil.post(`${configDomain}/buyer/login`, data)
  },
  fbLogin(data) {
    return HttpUtil.post(`${configDomain}/buyer/fblogin/outh/binding`, data)
  },
  ggLogin(data) {
    return HttpUtil.post(`${configDomain}/buyer/google/authUrl`, data)
  },
  sureRegister(data) {
    return HttpUtil.post(`${configDomain}/buyer/register/confirm`, data)
  },
  sendEmail(data) {
    return HttpUtil.post(`${configDomain}/buyer/email/send`, data)
  },
  /**
   * 用户退出接口
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  buyerOut (params) {
    let postUrl = configDomain + '/buyer/logout'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 订单总数
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  orderCount (params) {
    let postUrl = configDomain + '/buyer/order/count'
    return HttpUtil.get(postUrl, params)
  },
  /**
  * // 根据域名获取店铺信息
  * @param  {[type]} params [description]
  * @return {[type]}        [description]
  */
  getShopByDomain (params) {
    let postUrl = configDomain + '/bshop/config/domain/get/bydomain'
    return HttpUtil.get(postUrl, params)
  },
  /**
  * // 商品运费计算
  * @param  {[type]} params [description]
  * @return {[type]}        [description]
  */
  getFindlogistics (params) {
    let postUrl = configDomain + '/buyer/product/findlogistics/new'
    return HttpUtil.get(postUrl, params)
  },
  oceanpayment (params) {
    return HttpUtil.post('https://secure.oceanpayment.com/gateway/service/test', params)
  },
  payTypeList () {
    return HttpUtil.get(`${configDomain}/buyer/payment/type/list`)
  }
}
export default indexApi
